import { CloseRounded } from "@mui/icons-material";
import { Box, Button, IconButton, Stack, styled } from "@mui/material";
import moment from "moment";
import AppTextField from "./input-fields/AppTextField";
import AppModal from "components/AppModal";

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

import { DateRange } from "react-date-range";
import { useTranslation } from "react-i18next";

import { fr, enGB } from "date-fns/locale";

import i18next from "i18next";

const StyledAppModal = styled(AppModal)(({ theme }) => ({
  width: 400,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  [theme.breakpoints.down(400)]: {
    width: "96%",
  },
}));

export default function CustomDateRangePicker({
  open,
  setOpen,
  start,
  end,
  setStart,
  setEnd,
  disabled = false,
  onChangeCallback = () => {},
  minDate = true,
}) {
  const { t } = useTranslation();

  const handleClose = () => setOpen(false);

  const clear = () => {
    setStart(null);
    setEnd(null);
  };

  if (disabled) setOpen = () => {};

  const language = {
    fr: fr,
    en: enGB,
  };

  return (
    <Box>
      <Stack
        // direction="row"
        alignItems="center"
        direction={{ xs: "column", md: "row" }}
        // alignItems={{ md: "center" }}
        width="fit-content"
      >
        <Input
          setOpen={setOpen}
          name="start"
          label={t("DateRangePicker.start")}
          value={start}
          clear={clear}
          disabled={disabled}
        />
        <Box sx={{ mx: 2 }}> {t("DateRangePicker.to")} </Box>
        <Input
          setOpen={setOpen}
          name="end"
          label={t("DateRangePicker.end")}
          value={end}
          clear={clear}
          disabled={disabled}
        />
      </Stack>
      <StyledAppModal open={open} handleClose={handleClose}>
        <DateRange
          startDatePlaceholder={t("DateRangePicker.start")}
          endDatePlaceholder={t("DateRangePicker.end")}
          editableDateInputs={false}
          onChange={(item) => {
            setStart(item.selection.startDate);
            setEnd(item.selection.endDate);
            onChangeCallback(item.selection.startDate, item.selection.endDate);
          }}
          moveRangeOnFirstSelection={false}
          showMonthAndYearPickers={false}
          ranges={[
            {
              startDate: start || null,
              endDate: end || new Date(""),
              key: "selection",
            },
          ]}
          locale={language[i18next.language]}
        />
        <Button variant="outlined" onClick={handleClose}>
          {t("General.close")}
        </Button>
      </StyledAppModal>
    </Box>
  );
}

const Input = ({ name, label, value, clear, setOpen, disabled }) => {
  return (
    <AppTextField
      name={name}
      value={moment(value).isValid() ? moment(value).format("DD/MM/YYYY") : ""}
      onClick={() => setOpen(true)}
      sx={{ width: "150px" }}
      label={label}
      disabled={disabled}
      InputProps={{
        endAdornment: (
          <IconButton
            size="small"
            disabled={disabled}
            onClick={(e) => {
              e.stopPropagation();
              clear();
            }}
          >
            <CloseRounded fontSize="inherit" />
          </IconButton>
        ),
      }}
    />
  );
};
